import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-newFolderDialog',
  templateUrl: './newFolderDialog.component.html',
  styleUrls: ['./newFolderDialog.component.scss']
})
export class NewFolderDialogComponent implements OnInit {

  folderName = '';

  constructor(public dialogRef: MatDialogRef<NewFolderDialogComponent>) { }

  ngOnInit() { }
}
